const teamMembers = {
  pageTitle: {
    ja: "メンバー紹介 | 株式会社NAPIRE",
    en: "Team | NAPIRE Inc.",
  },
  metaDescription: {
    ja: "株式会社NAPIREのメンバー紹介。データサイエンティスト・エンジニア・PMの略歴と主要プロジェクト実績をご紹介します。",
    en: "Meet the NAPIRE team—bios and project track records across AI, cloud, and engineering.",
  },
  metaKeywords: {
    ja: "NAPIRE,メンバー,チーム,エンジニア,PM,AI,クラウド,プロジェクト実績",
    en: "NAPIRE,team,members,engineers,PM,AI,cloud,project track record",
  },
  hero: {
    eyebrow: { ja: "Team", en: "Team" },
    title: { ja: "メンバー紹介", en: "Our team" },
    lead: {
      ja: "役割・略歴・プロジェクト実績を中心にご紹介します。専門性と実績から、プロジェクトへの関わり方をご確認いただけます。",
      en: "We introduce our team through roles, backgrounds, and project records—so you can see how each role contributes on real engagements.",
    },
  },
  overviewLabel: { ja: "メンバー一覧", en: "Members" },
  detailLabel: { ja: "プロフィール", en: "Profile" },
  bioLabel: { ja: "略歴", en: "Background" },
  projectsLabel: { ja: "主要プロジェクト・職務経歴", en: "Projects & experience" },
  table: {
    role: { ja: "役割", en: "Role" },
    client: { ja: "お客様", en: "Client" },
    theme: { ja: "ご支援テーマ", en: "Engagement" },
    detail: { ja: "対応内容", en: "Scope" },
  },
  members: [
    {
      id: "riku",
      image: "team-riku.png",
      role: { ja: "データサイエンティスト / エンジニア", en: "Data scientist & engineer" },
      name: { ja: "長野 陸", en: "Riku Nagano" },
      reading: { ja: "ながの りく", en: "Riku Nagano" },
      age: { ja: "28歳", en: "28" },
      tags: {
        ja: ["データサイエンティスト", "エンジニア", "コンサルタント", "リサーチャー"],
        en: ["Data scientist", "Engineer", "Consultant", "Researcher"],
      },
      bio: {
        ja: [
          "大学を主席かつ飛び級で卒業し、AI・ITの専門性を深めるため大学院で研究",
          "大手のIT・通信企業グループにて、経営トップ直下で成長戦略のデータ分析・事業戦略を担当",
          "大手コンサルティングファームにて、AI・先端技術領域の事業戦略立案をリード",
          "多業種のシステム開発・要件整理・事業開発プロジェクトに幅広く参画",
          "経済産業省の高度IT人材として、地方自治体連携の地域DX推進を担当",
          "次世代経営人材育成プログラム、国のAI・サイバーセキュリティ人材育成事業に選出・参画",
        ],
        en: [
          "Graduated top of class with accelerated completion; pursued grad school to deepen AI & IT expertise",
          "At a major IT and telecom group—data analysis and growth strategy under top executive leadership",
          "At a leading consulting firm—led business strategy for AI and emerging technology domains",
          "Broad engagements across systems development, requirements, and business development across industries",
          "METI advanced IT talent—regional DX programs in partnership with local government",
          "Selected for executive development and national AI / cybersecurity talent programs",
        ],
      },
      projects: [
        { category: { ja: "AI", en: "AI" }, client: { ja: "法人向け", en: "Enterprise" }, theme: { ja: "業務効率化支援ツールの導入", en: "Workflow efficiency tooling" }, role: { ja: "戦略・設計", en: "Strategy & design" }, detail: { ja: "業務フロー整理、業務効率化提案", en: "Process mapping and efficiency proposals" } },
        { category: { ja: "ソフトウェア", en: "Software" }, client: { ja: "法人向け", en: "Enterprise" }, theme: { ja: "Webクローラシステムの導入", en: "Web crawler rollout" }, role: { ja: "設計", en: "Design" }, detail: { ja: "データ保存〜利活用までのフローの整理を支援", en: "End-to-end data capture and utilization flows" } },
        { category: { ja: "ハードウェア", en: "Hardware" }, client: { ja: "法人向け", en: "Enterprise" }, theme: { ja: "AR/VR/MRを用いた仮想空間での実地検証", en: "AR/VR/MR field validation" }, role: { ja: "要件整理", en: "Requirements" }, detail: { ja: "システム要件整理、導入までのプロセス提案", en: "Requirements through adoption roadmap" } },
        { category: { ja: "AI", en: "AI" }, client: { ja: "多業種", en: "Multi-industry" }, theme: { ja: "ビッグデータ分析・AI予測モデル・R&D", en: "Big data, forecasting, R&D" }, role: { ja: "実装", en: "Build" }, detail: { ja: "NLP、画像検出/認識、需要予測、音声認識/合成", en: "NLP, vision, demand forecasting, speech" } },
        { category: { ja: "ソフトウェア", en: "Software" }, client: { ja: "数十社以上", en: "30+ companies" }, theme: { ja: "Web/モバイル・API・インフラ", en: "Web/mobile, API, infra" }, role: { ja: "一気通貫", en: "End-to-end" }, detail: { ja: "第1〜3次産業まで幅広いシステム提供、セキュリティ脆弱性診断", en: "Cross-industry delivery and security assessment" } },
        { category: { ja: "ハードウェア", en: "Hardware" }, client: { ja: "自社/法人", en: "In-house & clients" }, theme: { ja: "自立型ドローン・植物工場", en: "Autonomous drones & plant factories" }, role: { ja: "開発", en: "Engineering" }, detail: { ja: "センサーフィードバック制御、回路設計・構築", en: "Sensor feedback control and circuit design" } },
      ],
    },
    {
      id: "hirata",
      image: "team-hirata.png",
      role: { ja: "コンサルタント / PM", en: "Consultant & PM" },
      name: { ja: "平田 大空", en: "Hirotaka Hirata" },
      reading: { ja: "ひらた ひろたか", en: "Hirotaka Hirata" },
      age: { ja: "29歳", en: "29" },
      tags: { ja: ["IT戦略", "ネットワーク基盤", "セキュリティ", "PM"], en: ["IT strategy", "Network architecture", "Security", "PM"] },
      bio: {
        ja: [
          "新卒でソフトバンクへ入社後、IT構想策定やロードマップ策定など幅広いコンサルティングに従事",
          "その後スタートアップで取締役に就任し、売上前期比5倍成長に貢献",
          "保有資格：CompTIA Project+、CompTIA Cloud+、Professional Google Workspace Administrator 等",
        ],
        en: [
          "Joined SoftBank as new grad—IT visioning, roadmaps, and consulting programs",
          "Later joined a startup as director; helped drive 5× YoY revenue growth",
          "CompTIA Project+, CompTIA Cloud+, Professional Google Workspace Administrator, and more",
        ],
      },
      projects: [
        { client: { ja: "自動車業界", en: "Automotive" }, theme: { ja: "中期事業計画策定", en: "Mid-term business plan" }, role: { ja: "PM", en: "PM" }, detail: { ja: "業界共通NW基盤としてデータ主権を重んじたあるべき姿と実行計画を策定", en: "Target-state and execution plan for a data-sovereign industry network" } },
        { client: { ja: "エンタメ大手", en: "Entertainment" }, theme: { ja: "次期NW基盤構想RFP", en: "Next-gen network RFP" }, role: { ja: "PM", en: "PM" }, detail: { ja: "ユーザフレンドリーなNW環境をテーマにRFPを作成し、競合4社中最高点で受注", en: "User-friendly network RFP; top score among four vendors and won the deal" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "基幹システム業務ヒアリング", en: "ERP field discovery" }, role: { ja: "PM", en: "PM" }, detail: { ja: "主要拠点を訪問して生の声を集約し、第三者視点でグランドデザインを提言", en: "Multi-site interviews and third-party grand-design recommendations" } },
        { client: { ja: "人材業界", en: "HR tech" }, theme: { ja: "人材プラットフォーム開発", en: "Talent platform" }, role: { ja: "PM", en: "PM" }, detail: { ja: "オフショア連携でAI機能実装・インフラ改修・運用トラブルシューティング", en: "Offshore-led AI features, infra fixes, and ops troubleshooting" } },
        { client: { ja: "エンタメ業界", en: "Entertainment" }, theme: { ja: "検索プラットフォーム開発", en: "Search platform" }, role: { ja: "PMO", en: "PMO" }, detail: { ja: "インバウンド要素とAI要素をくみ取り、設計フェーズへの橋渡しを実施", en: "Bridged inbound and AI requirements into the design phase" } },
        { client: { ja: "アパレル業界", en: "Apparel" }, theme: { ja: "システム連携API開発", en: "Integration API" }, role: { ja: "PMO", en: "PMO" }, detail: { ja: "Channel talkとSalesforceを連携する独自APIを開発", en: "Custom API linking Channel talk and Salesforce" } },
        { client: { ja: "食品製造業", en: "Food manufacturing" }, theme: { ja: "セキュリティロードマップ策定", en: "Security roadmap" }, role: { ja: "メンバー", en: "Member" }, detail: { ja: "NIST CSF・セキュリティ白書等を用いたセキュリティグランドデザインを描出", en: "Security grand design using NIST CSF and JP frameworks" } },
      ],
    },
    {
      id: "aimoto",
      image: "team-aimoto.png",
      role: { ja: "テックリード / エンジニア", en: "Tech lead & engineer" },
      name: { ja: "相本 健", en: "Takeshi Aimoto" },
      reading: { ja: "あいもと たけし", en: "Takeshi Aimoto" },
      age: { ja: "29歳", en: "29" },
      tags: { ja: ["Power Platform", "xR / AR", "生成AI", "RAG"], en: ["Power Platform", "xR / AR", "GenAI", "RAG"] },
      bio: {
        ja: [
          "新卒で三菱電機系列のITベンダーへ入社。要件定義から開発・運用まで経験",
          "AI、xR、メタバースなどの先端技術開発にも携わる",
          "スタートアップでマネージャーとして案件遂行とディレクション",
          "保有資格：Power Platform Fundamentals",
        ],
        en: [
          "Joined Mitsubishi Electric–group IT vendor; requirements through ops",
          "Advanced work in AI, xR, and metaverse",
          "Startup manager—delivery and technical direction",
          "Power Platform Fundamentals certified",
        ],
      },
      projects: [
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "業務改革支援（Power Platform）", en: "Power Platform modernization" }, role: { ja: "PM / PMO", en: "PM / PMO" }, detail: { ja: "提案からPoC、設計、開発、テスト、導入まで実施", en: "Proposal through PoC, build, test, and rollout" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "xRシステム開発", en: "xR systems" }, role: { ja: "PM / エンジニア", en: "PM / engineer" }, detail: { ja: "AR/MR業務システム開発と特許出願", en: "AR/MR ops systems and patent filing" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "数理最適化AI", en: "Optimization AI" }, role: { ja: "PM / エンジニア", en: "PM / engineer" }, detail: { ja: "数理最適化モデルを活用したWebシステム", en: "Web app powered by optimization models" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "メタバース開発", en: "Metaverse" }, role: { ja: "PM / エンジニア", en: "PM / engineer" }, detail: { ja: "メタバース開発とChatGPTチャットボット導入", en: "Metaverse build plus ChatGPT bot" } },
        { client: { ja: "エンタメ業界", en: "Entertainment" }, theme: { ja: "検索プラットフォーム開発", en: "Search platform" }, role: { ja: "PM", en: "PM" }, detail: { ja: "インバウンド×AIの要件定義・設計・AI機能PoC", en: "Inbound × AI requirements, design, and AI PoC" } },
        { client: { ja: "アパレル業界", en: "Apparel" }, theme: { ja: "システム連携API開発", en: "Integration API" }, role: { ja: "PM", en: "PM" }, detail: { ja: "Channel talkとSalesforceを連携する独自APIを開発", en: "Custom API linking Channel talk and Salesforce" } },
        { client: { ja: "建築業界", en: "Construction" }, theme: { ja: "リスキリングAIツール", en: "Reskilling AI tool" }, role: { ja: "PM", en: "PM" }, detail: { ja: "GPTsで営業トークシミュレーションを開発", en: "GPTs sales-talk simulation" } },
        { client: { ja: "人材業界", en: "HR tech" }, theme: { ja: "プロダクト改修", en: "Product enhancement" }, role: { ja: "TL", en: "TL" }, detail: { ja: "オフショア連携で機能改修・AI実装・インフラ改修・運用TS", en: "Offshore-led feature, AI, infra, and ops fixes" } },
        { client: { ja: "IT業界", en: "IT" }, theme: { ja: "動画判定AI", en: "Video moderation AI" }, role: { ja: "エンジニア", en: "Engineer" }, detail: { ja: "生成AIモデルを活用した危険動画判定APIを開発", en: "Hazard video detection API with generative models" } },
        { client: { ja: "IT業界", en: "IT" }, theme: { ja: "PowerPoint作成AI Agent", en: "PowerPoint AI agent" }, role: { ja: "エンジニア", en: "Engineer" }, detail: { ja: "客先フォーマットに合わせたPowerPoint出力Agentを開発", en: "Client-format PowerPoint output agent" } },
        { client: { ja: "金融業界", en: "Finance" }, theme: { ja: "承認システム開発", en: "Approval system" }, role: { ja: "エンジニア", en: "Engineer" }, detail: { ja: "Power Platformを活用した承認システムを開発", en: "Approval workflow built on Power Platform" } },
        { client: { ja: "IT業界", en: "IT" }, theme: { ja: "社内文書RAGシステム", en: "Internal document RAG" }, role: { ja: "コンサル / エンジニア", en: "Consulting / engineer" }, detail: { ja: "AWS上に社内文書を登録したRAGシステムの策定と開発", en: "Designed and built an AWS-hosted internal document RAG system" } },
      ],
    },
    {
      id: "nakano",
      image: "team-nakano.png",
      role: { ja: "PM / PMO", en: "PM / PMO" },
      name: { ja: "中野 二三章", en: "Fumiyuki Nakano" },
      reading: { ja: "なかの ふみゆき", en: "Fumiyuki Nakano" },
      age: { ja: "29歳", en: "29" },
      tags: { ja: ["大規模システム導入", "通信インフラ", "組織マネジメント", "業務フロー設計"], en: ["Large-scale rollout", "Telecom infra", "Org leadership", "Process design"] },
      bio: {
        ja: [
          "楽天モバイルにて基地局設置営業を経験後、基地局設計・工事見積精査・ドキュメント統括に従事",
          "約40名規模の設計管理グループVGMとして、本社建設部との折衝・方針決定を担当",
          "法人事業本部でシステム導入PJTのPM/PMOを複数担当",
          "請求書発行システムを2ヶ月強で選定〜本番運用開始まで完遂",
        ],
        en: [
          "Rakuten Mobile—site sales, then design, estimate review, and document governance",
          "VGM for ~40-person design org; regional lead vs. HQ construction",
          "Multiple system rollout PM/PMO programs in enterprise division",
          "Billing system live in ~2 months from selection",
        ],
      },
      projects: [
        { client: { ja: "通信業界", en: "Telecom" }, theme: { ja: "基地局設置営業", en: "Site acquisition sales" }, role: { ja: "営業", en: "Sales" }, detail: { ja: "23局の設置合意。工事中止率10%（営業30名中2位）", en: "23 site agreements; 10% cancel rate (#2 of 30)" } },
        { client: { ja: "通信業界", en: "Telecom" }, theme: { ja: "工事見積精査／ドキュメント管理", en: "Estimate & document control" }, role: { ja: "リーダー", en: "Lead" }, detail: { ja: "206局承認、ドキュメントチーム統括（約10名）", en: "206 approvals; ~10-person doc team lead" } },
        { client: { ja: "通信業界", en: "Telecom" }, theme: { ja: "部材・成果物提出管理", en: "Materials & deliverables" }, role: { ja: "統括補佐", en: "Deputy lead" }, detail: { ja: "完成図書提出促進体制を構築。KPI達成率100%超（最大489%）", en: "As-built submission framework; KPI over 100% (peak 489%)" } },
        { client: { ja: "通信業界", en: "Telecom" }, theme: { ja: "設計管理／地域代表", en: "Design management" }, role: { ja: "VGM", en: "VGM" }, detail: { ja: "約40名統括、本社折衝・地域方針決定。図面修正費抑制（221局＋202局影響）", en: "~40 FTE org; drawing cost control across 221+202 sites" } },
        { client: { ja: "通信業界", en: "Telecom" }, theme: { ja: "大規模設計方針変更対応", en: "Major design-policy change" }, role: { ja: "意思決定", en: "Decision lead" }, detail: { ja: "5G図面提出の一時停止判断など、修正費・工数削減を主導", en: "Paused 5G drawing submissions to cut rework cost and effort" } },
        { client: { ja: "法人事業", en: "Enterprise" }, theme: { ja: "請求書発行システム導入", en: "Billing system rollout" }, role: { ja: "PMO", en: "PMO" }, detail: { ja: "選定〜本番運用まで2ヶ月強で完遂。社内外調整・契約・業務フロー整理", en: "Selection to production in ~2 months; contracts and process design" } },
        { client: { ja: "法人事業", en: "Enterprise" }, theme: { ja: "販売管理システム導入", en: "Sales ops system" }, role: { ja: "PM", en: "PM" }, detail: { ja: "フロー整理・ユーザーテスト調整・複数PJT並行管理", en: "Process design, UAT coordination, and multi-project delivery" } },
        { client: { ja: "法人事業", en: "Enterprise" }, theme: { ja: "業務フロー構築", en: "Process design" }, role: { ja: "PM", en: "PM" }, detail: { ja: "インボイス制度対応、代理店戻入金回収フローを構築", en: "Invoice-regime and agency rebate recovery flows" } },
        { client: { ja: "法人事業", en: "Enterprise" }, theme: { ja: "組織・人材育成", en: "Org & talent development" }, role: { ja: "マネジャー", en: "Manager" }, detail: { ja: "新卒育成、組織体制再設計、引継ぎ設計を推進", en: "New-grad coaching, org redesign, and handoff design" } },
      ],
    },
    {
      id: "kodaka",
      image: "team-kodaka.png",
      role: { ja: "コンサルタント / PM", en: "Consultant & PM" },
      name: { ja: "小高 健人", en: "Kento Kodaka" },
      reading: { ja: "こだか けんと", en: "Kento Kodaka" },
      age: { ja: "29歳", en: "29" },
      tags: { ja: ["進捗管理", "スクラム", "データ活用", "ベンダー管理"], en: ["Delivery mgmt", "Scrum", "Data enablement", "Vendor mgmt"] },
      bio: {
        ja: [
          "楽天モバイルにて、基地局設置の進捗管理・データ管理グループ立ち上げをリーダーとして経験",
          "ベイカレントでは業務整理・ToBe設計に加え、自らプロト／システムを作りながら実装寄りで推進",
          "オフショア開発マネジメントも経験し、要件〜設計〜実装〜運用を一気通貫で回した経験あり",
          "ビジネス側とシステム側の両方の知見を活かし、自走しつつ橋渡しをする",
        ],
        en: [
          "Rakuten Mobile—led site-build progress control and a new data-management group",
          "BayCurrent: ToBe design plus hands-on prototyping to keep programs moving",
          "Offshore program management from requirements through ops",
          "Bridges business and engineering while driving delivery independently",
        ],
      },
      projects: [
        { client: { ja: "通信業界", en: "Telecom" }, theme: { ja: "基地局設置進捗管理／データ管理G立上げ", en: "Site-build progress & data org" }, role: { ja: "メンバー / リーダー", en: "Member / lead" }, detail: { ja: "中四国エリアの進捗管理〜5G設置統括。横断データ管理Gを立上げ、年間MVP受賞", en: "Chugoku-Shikoku progress and 5G lead; founded cross-org data group; annual MVP" } },
        { client: { ja: "自動車業界", en: "Automotive" }, theme: { ja: "次世代カーナビシステム開発支援", en: "Next-gen car navigation" }, role: { ja: "スクラムマスター", en: "Scrum master" }, detail: { ja: "海外ベンダー2社管理、英語会議進行、JIRA一元化。韓国出張3度帯同", en: "Managed 2 overseas vendors, English facilitation, JIRA; 3 Korea trips" } },
        { client: { ja: "クレジットカード業界", en: "Credit cards" }, theme: { ja: "SASプログラム改修", en: "SAS program changes" }, role: { ja: "データエンジニア", en: "Data engineer" }, detail: { ja: "商品性改定に伴う改修要否判定〜改修・テスト。本部長向け月次報告資料を作成", en: "Change impact, SAS build/test, and monthly exec reporting" } },
        { client: { ja: "電力業界", en: "Energy" }, theme: { ja: "SaaSシステムリプレイス", en: "SaaS replacement" }, role: { ja: "PMO", en: "PMO" }, detail: { ja: "遅延局面から参画。マスタースケジュール・WBS・総合テストシナリオを整備", en: "Joined mid-delay; rebuilt master schedule, WBS, and integration-test scenarios" } },
      ],
    },
    {
      id: "mahmoud",
      image: "team-mahmoud.png",
      role: { ja: "フルスタックエンジニア", en: "Full-stack engineer" },
      name: { ja: "MAHMOUD DABBAGH", en: "MAHMOUD DABBAGH" },
      reading: { ja: "マフムード・ダッバグ", en: "Mahmoud Dabbagh" },
      age: { ja: "", en: "" },
      tags: { ja: ["AWS", "Docker", "機械学習", "データパイプライン"], en: ["AWS", "Docker", "Machine learning", "Data pipelines"] },
      bio: {
        ja: [
          "在学中から複数IT企業で学生インターンとしてフルスタックエンジニア経験",
          "AI開発スタートアップでAI開発ノウハウを蓄積",
          "4か国語を操り、多文化環境でのプロジェクト推進が可能",
        ],
        en: [
          "Student internships as full-stack engineer at multiple IT firms",
          "AI startup—production ML and data pipelines",
          "Quadrilingual—comfortable leading in multicultural teams",
        ],
      },
      projects: [
        { client: { ja: "IT業界", en: "IT" }, theme: { ja: "データ基盤開発", en: "Data platform" }, role: { ja: "フルスタック", en: "Full-stack" }, detail: { ja: "設計〜構築〜運用、データパイプラインおよびビッグデータ分析基盤", en: "Design, build, ops—pipelines and analytics foundation" } },
        { client: { ja: "IT業界", en: "IT" }, theme: { ja: "プロダクト改修", en: "Product work" }, role: { ja: "フルスタック", en: "Full-stack" }, detail: { ja: "Docker開発環境、AWSインフラ構築・運用", en: "Docker dev envs and AWS infra" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "基幹システムリプレイス", en: "ERP replacement" }, role: { ja: "フルスタック", en: "Full-stack" }, detail: { ja: "既存基幹をWebシステムとしてリプレイス", en: "Legacy ERP to modern web stack" } },
        { client: { ja: "社内", en: "Internal" }, theme: { ja: "画像認識AI PoC", en: "Vision AI PoC" }, role: { ja: "フルスタック", en: "Full-stack" }, detail: { ja: "ホワイトアウト動画から物体検出、モデル蒸留でAndroid軽量化", en: "Detection on washed-out video; distilled models for Android" } },
      ],
    },
    {
      id: "ishibashi",
      image: "team-ishibashi.png",
      role: { ja: "PM / 営業", en: "PM & sales" },
      name: { ja: "石橋 廉", en: "Ren Ishibashi" },
      reading: { ja: "いしばし れん", en: "Ren Ishibashi" },
      age: { ja: "30歳", en: "30" },
      tags: { ja: ["M365 / Copilot", "生成AI提案", "基幹リプレイス", "SNSマーケ"], en: ["M365 / Copilot", "GenAI proposals", "ERP replacement", "SNS marketing"] },
      bio: {
        ja: [
          "不妊技師として高度生殖補助医療に貢献し、系列病院の立ち上げに参画",
          "システム開発会社へ転職し、営業職として経験を積む",
          "顧客折衝能力を活かし、PMとして開発業務を推進",
          "M365（Copilot）の知識を活かし、営業コンサルタントとして販社支援を行う",
        ],
        en: [
          "Clinical embryologist in advanced reproductive medicine; helped launch an affiliated hospital",
          "Moved to a systems integrator in a sales role",
          "PM leveraging strong client communication",
          "Sales consultant supporting partners with M365 and Copilot",
        ],
      },
      projects: [
        { client: { ja: "事業会社・社団法人等", en: "Enterprises & associations" }, theme: { ja: "生成AIサービス提案", en: "GenAI services" }, role: { ja: "営業", en: "Sales" }, detail: { ja: "生成AIサービスを徹底リサーチし、事業機会を発掘。最適なビジネスモデルを考慮した提案", en: "Market scan and business-model proposals for GenAI opportunities" } },
        { client: { ja: "社内", en: "Internal" }, theme: { ja: "SNSマーケティング", en: "SNS marketing" }, role: { ja: "マーケ", en: "Marketing" }, detail: { ja: "YouTube/X/LinkedIn施策企画・実行、社外交渉", en: "YouTube/X/LinkedIn programs and vendor coordination" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "営業", en: "Sales" }, role: { ja: "営業", en: "Sales" }, detail: { ja: "ヒアリングから提案資料作成・成約。3000万円規模の大型案件", en: "Discovery to close—¥30M deal" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "基幹システムリプレイス", en: "ERP replacement" }, role: { ja: "PM", en: "PM" }, detail: { ja: "要件整理〜基本設計、10人開発チーム統率", en: "Requirements through basic design; 10-person squad" } },
        { client: { ja: "通信業", en: "Telecom" }, theme: { ja: "M365・Copilot導入・運用支援", en: "M365 & Copilot adoption" }, role: { ja: "営業コンサル", en: "Sales consultant" }, detail: { ja: "導入・運用支援、提案資料作成、デモ・セミナーによる販売促進", en: "Adoption support, proposals, demos, and partner enablement seminars" } },
      ],
    },
    {
      id: "nogami",
      image: "team-nogami.png",
      role: { ja: "PM / PMO", en: "PM / PMO" },
      name: { ja: "野上 拓暉", en: "Hiroki Nogami" },
      reading: { ja: "のがみ ひろき", en: "Hiroki Nogami" },
      age: { ja: "29歳", en: "29" },
      tags: { ja: ["小売・店舗開発", "基幹リプレイス", "クラウド移行", "SNSマーケ"], en: ["Retail expansion", "ERP replacement", "Cloud migration", "SNS marketing"] },
      bio: {
        ja: [
          "家具メーカーの営業として、既存顧客を中心としたルート営業に従事",
          "販売店への提案から納品後フォローまで一貫対応し、長期的な関係構築に貢献",
          "システム開発会社へ転職し営業経験後、問題解決型の営業経験を活かしPMとして開発を推進",
        ],
        en: [
          "Furniture maker sales—route accounts focused on existing retailers",
          "End-to-end proposals through post-delivery follow-up and long-term relationships",
          "Systems integrator sales, then PM leveraging problem-solving sales experience",
        ],
      },
      projects: [
        { client: { ja: "小売業", en: "Retail" }, theme: { ja: "オリジナルブランド店舗展開", en: "Brand store rollout" }, role: { ja: "営業/PM", en: "Sales/PM" }, detail: { ja: "全国19店舗のうち6店舗立ち上げ。売上3.9億円のうち約1.45億円を達成", en: "Led 6 of 19 national openings; ¥145M of ¥390M program revenue" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "基幹システムリプレイス", en: "ERP replacement" }, role: { ja: "PMO", en: "PMO" }, detail: { ja: "要件整理〜基本設計、10人チームの進捗管理サポート", en: "Requirements through basic design; squad progress PMO" } },
        { client: { ja: "通信業", en: "Telecom" }, theme: { ja: "基幹システムクラウド移行", en: "Core system cloud migration" }, role: { ja: "PMO", en: "PMO" }, detail: { ja: "オンプレからクラウドへの移行後、安定稼働に向けた運用体制・問い合わせ対応を支援", en: "Post-migration ops readiness, inquiry handling, and process adoption" } },
        { client: { ja: "社内", en: "Internal" }, theme: { ja: "SNSマーケティング", en: "SNS marketing" }, role: { ja: "マーケ", en: "Marketing" }, detail: { ja: "YouTube/X/LinkedIn施策、社外担当者との交渉", en: "Social programs and external partner coordination" } },
      ],
    },
    {
      id: "nguyen",
      image: "team-nguyen.png",
      role: { ja: "システムエンジニア", en: "Software engineer" },
      name: { ja: "NGUYEN CHAM", en: "NGUYEN CHAM" },
      reading: { ja: "グェン チャム", en: "Nguyen Cham" },
      age: { ja: "", en: "" },
      tags: { ja: ["Ruby", "React", "Vue", "TypeScript"], en: ["Ruby", "React", "Vue", "TypeScript"] },
      bio: {
        ja: [
          "建設資材商社、食品製造、IT企業で経理・総務・外国人従業員サポート等を経験",
          "システムエンジニアとしてWebシステムの保守・運用・改修に従事",
          "Ruby/Rails、PHP、Vue、React、TypeScript。Docker/Git/GitHub/Bitbucket運用経験",
        ],
        en: [
          "Accounting, HR, and expat support across construction, food, and IT firms",
          "Maintains and enhances web systems as SE",
          "Ruby/Rails, PHP, Vue, React, TS; Docker and Git workflows",
        ],
      },
      projects: [
        { client: { ja: "建設資材商社", en: "Construction supply" }, theme: { ja: "経理・車両運行管理", en: "Finance & fleet" }, role: { ja: "メンバー", en: "Member" }, detail: { ja: "給与計算、建設資材運搬車両の配車調整・運行スケジュール管理", en: "Payroll plus construction-fleet dispatch and scheduling" } },
        { client: { ja: "食品製造業", en: "Food manufacturing" }, theme: { ja: "外国人従業員サポート", en: "Expat support" }, role: { ja: "メンバー", en: "Member" }, detail: { ja: "技能実習・特定技能の通訳翻訳、在留手続き、入社・生活・社員寮管理", en: "Interpretation, visas, onboarding, housing, and dorm management" } },
        { client: { ja: "製造業", en: "Manufacturing" }, theme: { ja: "Webシステム保守運用", en: "Web maintenance" }, role: { ja: "エンジニア", en: "Engineer" }, detail: { ja: "Ruby/Rails/SQLで保守・改修・不具合調査", en: "Rails/SQL maintenance and defect fixes" } },
        { client: { ja: "アパレル業界", en: "Apparel" }, theme: { ja: "EC Web改修", en: "E-commerce web" }, role: { ja: "エンジニア", en: "Engineer" }, detail: { ja: "Vue.js/JS/PostgreSQLで機能追加・改善", en: "Vue/JS/Postgres feature work" } },
        { client: { ja: "小売業界", en: "Retail" }, theme: { ja: "Web保守・改善", en: "Web enhancement" }, role: { ja: "エンジニア", en: "Engineer" }, detail: { ja: "React/TSフロント、バックエンド連携、Docker/Sandbox、Gitチーム開発サポート", en: "React/TS front-end, backend integration, Docker sandbox, and Git collaboration" } },
      ],
    },
  ],
}
